/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

// import { useTheme } from '../../contexts/ThemeContext';
import { useTheme, useThemeClassName } from '../../contexts/ThemeContext';
import Coupon from '../prizes/Coupon';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../../styles/partials/stats.module.scss';

const propTypes = {
    stats: PropTypes.arrayOf(PropTypes.shape({})),
    display: PropTypes.oneOf(['normal', 'table']),
    className: PropTypes.string,
    statsClassName: PropTypes.string,
    valueClassName: PropTypes.string,
    labelClassName: PropTypes.string,
};

const defaultProps = {
    stats: null,
    display: 'normal',
    className: null,
    statsClassName: null,
    valueClassName: null,
    labelClassName: null,
};

function Stats({ stats, display, className, statsClassName, valueClassName, labelClassName }) {
    const themeClassName = useThemeClassName(styles);
    const { name: themeName, isVariant } = useTheme();

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                className,
                {
                    [styles[`${display}Display`]]: display !== null,
                },
            ])}
        >
            {(stats || []).map(({ label, value, draw = null }, index) => {
                const statsElement = (
                    <div
                        className={classNames([
                            styles.stats,
                            {
                                [statsClassName]: statsClassName !== null,
                            },
                        ])}
                        key={`stats-${index}`}
                    >
                        <div
                            className={classNames([
                                styles.value,
                                {
                                    [valueClassName]: valueClassName !== null,
                                },
                            ])}
                        >
                            {value}
                        </div>
                        <div
                            className={classNames([
                                styles.label,
                                {
                                    [labelClassName]: labelClassName !== null,
                                },
                            ])}
                        >
                            {label}
                        </div>
                    </div>
                );
                if (
                    draw !== null &&
                    draw.handle === 'weekly' &&
                    themeName === 'iga_noel' &&
                    isVariant('bonichoix')
                ) {
                    const { prizes = null } = draw;
                    const [drawPrize = null] = prizes || [];
                    const { prize } = drawPrize || {};
                    const { image: prizeImage = null } = prize || {};
                    return (
                        <div className={styles.wrapper} key={`stats-${index}`}>
                            <div className={styles.prize}>
                                {prizeImage !== null ? (
                                    <img src={prizeImage.url} className={styles.prizeImage} />
                                ) : null}
                                <div className={styles.prizeLabel}>
                                    <h4 className={styles.title}>
                                        <FormattedMessage
                                            defaultMessage="Good luck!"
                                            description="Bonichoix draw title"
                                        />
                                    </h4>
                                    <p className={styles.description}>
                                        <FormattedMessage
                                            defaultMessage="You could win a $250 RICARDO gift card"
                                            description="Bonichoix draw title"
                                        />
                                    </p>
                                </div>
                            </div>
                            {statsElement}
                        </div>
                    );
                }
                return statsElement;
            })}
        </div>
    );
}

Stats.propTypes = propTypes;
Stats.defaultProps = defaultProps;

export default Stats;
